export enum EReportStatus {
  PROCESSING = 'PROCESSING',
  READY_FOR_SMS = 'READY_FOR_SMS',
  READY_FOR_DOWNLOAD = 'READY_FOR_DOWNLOAD',
  DOWNLOADED = 'DOWNLOADED',
  FAILED = 'FAILED',
}
